/** Muted, print-like accents matching the Methacore palette. */
export const USER_COLORS = [
  "#1f7a72",
  "#b4532a",
  "#3a5ba0",
  "#7a5aa8",
  "#8a7320",
  "#a63d5f",
  "#2f6b3d",
  "#5c5f66",
] as const;

function hash(input: string): number {
  let value = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    value ^= input.charCodeAt(i);
    value = Math.imul(value, 16777619);
  }
  return Math.abs(value);
}

export function colorForUser(userId: string): string {
  return USER_COLORS[hash(userId) % USER_COLORS.length];
}

export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}
